@use "ui/styles/colorsOld";

.wrapper {
  td {
    font-size: 14px;
    line-height: 130%;

    padding: 6px 10px 6px 0;

    &:first-child {
      color: colorsOld.$stoneDark;
    }

    &:last-child {
      color: colorsOld.$stoneDarkX1;
    }
  }
}
